import {configureStore, combineReducers} from '@reduxjs/toolkit';
import {persistStore} from 'redux-persist';
import {thunk} from 'redux-thunk';

import {createPersistedReducer} from './utils/store';
import * as UserStore from './user';
import * as TasksStore from './tasks';
import * as AppStore from './app';
import * as HiJetStore from './hiJet';

const rootReducer = combineReducers({
  [UserStore.APP_STORE_NAME]: UserStore.reducer,
  [TasksStore.APP_STORE_NAME]: TasksStore.reducer,
  [AppStore.APP_STORE_NAME]: AppStore.reducer,
  [HiJetStore.APP_STORE_NAME]: HiJetStore.reducer,
});

const persistedReducer = createPersistedReducer({
  key: 'redux_storage',
  reducer: rootReducer,
  whitelist: ['user'],
  blacklist: [],
});

const store = configureStore({
  reducer: persistedReducer,
  middleware: () => [thunk],
});

export const persistor = persistStore(store);
export const purgePersistor = () => persistor.purge();

export default store;
